import localforage from "localforage";
import { useEffect } from "react";
import { redirect, useLoaderData, useNavigate } from "react-router-dom";
import bevzLogo from "../../assets/v2/bevzLogo.png";
import Footer from "../../components/v2/Footer/Footer";
import { useStoreDispatch } from "../../context/CreateStoreContext";
import style from "./ThankYou.module.css";
import { Button, Col, Flex, Grid, Row, Typography } from "antd";
import { ArrowLeftOutlined } from "@ant-design/icons";
import thankyouImgTablet from "../../assets/v2/thank_you_tablet.png";

const { Title } = Typography;
const { useBreakpoint } = Grid;

export async function loader({ request }) {
  const url = new URL(request.url);
  const isFromAdmin = url.searchParams.get("admin") === "true";

  try {
    const store = await localforage.getItem("storeV2");
    if (!store?.store) {
      // return isFromAdmin ? redirect("/dashboard") : redirect("/");
    }
    return {
      store: store?.store,
      isFromAdmin: isFromAdmin,
      completing: store?.stripeClient?.completing || false,
    };
  } catch (err) {
    console.log(err);
    return redirect("/");
  }
}

export default function ThankYou() {
  const { store, isFromAdmin, completing = false } = useLoaderData();
  const screen = useBreakpoint();
  const dispatch = useStoreDispatch();
  const navigate = useNavigate();

  const handleClick = () => {
    isFromAdmin
      ? navigate("/dashboard", { replace: true })
      : navigate("/login", { replace: true });
  };

  useEffect(() => {
    if (isFromAdmin) {
    } else {
      // dispatch({ type: ACTIONTYPES.CLEAR_FORM_STATES });
    }
  }, []);

  return (
    <>
      <Row className={style.ThankYou}>
        <Col
          xs={{ span: 22, offset: 1, order: 2 }}
          lg={{ span: 14, offset: 0, order: 1 }}
          xl={{ span: 14, offset: 0 }}
        >
          <Row style={{ height: "100%" }}>
            <Col
              xs={{ span: 20, offset: 2 }}
              md={{ span: 14, offset: 5 }}
              lg={{ span: 16, offset: 6 }}
              xl={{ span: 10, offset: 10 }}
            >
              <Flex justify="center" vertical className={style.Container}>
                <img
                  src={bevzLogo}
                  width="171px"
                  height="115px"
                  className="BevzLogo"
                />
                <Title
                  level={screen.xs ? 4 : 3}
                  className={style.thankyouSubHeader}
                >
                  {isFromAdmin && !completing
                    ? "Thanks for sticking with us!"
                    : "Thank you for joining us!"}
                </Title>
                <Title
                  level={screen.xs ? 2 : 1}
                  className={style.thankyouHeader}
                >
                  {isFromAdmin && !completing
                    ? "New store has been added!"
                    : "Your store account is now active!"}
                </Title>
                <Row className={style.storeDetails}>
                  <Col span={24} className={style.storeName}>
                    {store?.name}
                  </Col>
                  <Col span={24} className={style.storeAddress}>
                    {store?.address?.street1} {store?.address?.street2}{" "}
                    {store?.address?.city} {store?.address?.state}{" "}
                    {store?.address?.zipCode}, USA
                  </Col>
                </Row>

                <div className={style.notice}>
                  You'll receive a welcome email from bevz shortly with more
                  details to help you get started.
                  <br />
                  <br />
                  If you have any questions, please call us on{" "}
                  <a href="tel:8182351327">(818) 235-1327</a> or email us at{" "}
                  <a href="mailto:support@bevz.com">support@bevz.com</a>
                </div>

                <Button
                  size="large"
                  onClick={handleClick}
                  className={style.brand_button}
                  iconPosition="start"
                  icon={isFromAdmin ? <ArrowLeftOutlined /> : null}
                >
                  {isFromAdmin ? "Back to My Account" : "Login to My Account"}
                </Button>
              </Flex>
            </Col>
          </Row>
        </Col>
        <Col
          xs={{ span: 22, offset: 1, order: 1 }}
          lg={{ span: 9, offset: 1, order: 2 }}
          xl={{ span: 10, offset: 0 }}
          className={style.Right}
        >
          <img
            src={thankyouImgTablet}
            alt="Thank You"
            className={style.ThankYouImg}
          />
        </Col>
      </Row>

      <Footer />
    </>
  );
}
